// extracted by mini-css-extract-plugin
export var addButton = "_i4-0";
export var border = "_i4-8";
export var check = "_i4-h";
export var danger = "_i4-6";
export var dropdownContainer = "_i4-1";
export var editModalBody = "_i4-j";
export var footerContainer = "_i4-i";
export var fullWidth = "_i4-a";
export var hide = "_i4-9";
export var icon = "_i4-3";
export var input = "_i4-7";
export var inputFlex = "_i4-b";
export var inputWrapper = "_i4-c";
export var manualFocus = "_i4-5";
export var optionButton = "_i4-4";
export var pillWrapper = "_i4-e";
export var pointer = "_i4-2";
export var showOverflow = "_i4-f";
export var tagsFlex = "_i4-d";
export var xButton = "_i4-g";